<template>
  <div>
    <LoadingButton
      title='добавить название'
      type="button"
      :loading="loading"
      :onClick="() => addNewTitle()"
      :color="$constants.SUCCESS_COLOR"
      className="btn btn-xs btn-outline-success mb-1"
    />
    <div v-if="records && records.length">
      <template v-for="(r, i) in records">
        <div class="input-group"
             v-if="['country_data', 'supplier_data'].includes(r.group_alias) && r.alias === 'title'">
          <input type="text" :disabled="r.to_delete" placeholder="Название препарата" v-model="r.text_value"
                 class="form-control">
          <div class="input-group-append w-35">
            <select class="form-control" :disabled="r.to_delete" @change="updateType(i)" v-model="r.group_alias">
              <option value="supplier_data">поставщик</option>
              <option value="country_data">страна</option>
            </select>
            <select class="form-control" :disabled="r.to_delete" v-model="r.int_value"
                    v-if="r.group_alias === 'country_data'">
              <option value="0">любая страна</option>
              <option v-for="s in countries" :value="s.id">{{ s.title }}</option>
            </select>
            <select class="form-control" :disabled="r.to_delete" v-model="r.int_value"
                    v-if="r.group_alias === 'supplier_data'">
              <option value="0">любой поставщик</option>
              <option v-for="s in suppliers" :value="s.id">{{ s.title }} | {{ countries[s.country_id]?.title }}
              </option>
            </select>
            <button class="btn btn-default" type="button" @click="r.to_delete = !r.to_delete">
              <i class="icon-fa icon-fa-remove"/>
            </button>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>

import LoadingButton from "@/components/buttons/LoadingButton.vue";
import api from "@/api";

export default {
  components: {LoadingButton},
  props: ['records'],
  data() {
    return {
      suppliers: [],
      countries: {},
      loading: false,
    }
  },
  computed: {
    $AllCountries() {
      return this.$store.getters['platform/countries'];
    },
  },
  created() {
    if (this.records.length) {
      this.getSuppliers();
    }
    this.countries = Object.values(this.$AllCountries).reduce((acc, c) => {
      acc[c.id] = {...c};
      return acc;
    }, {});
    this.records.forEach((r, i) => {
      // r.select_type = r.alias === 'supplier_title' ? 1 : 2;
      this.$set(this.records[i], 'to_delete', false);
    })
  },
  methods: {
    updateType(index) {
      this.records[index].int_value = 0;
    },
    async addNewTitle() {
      if (!this.suppliers.length) {
        await this.getSuppliers();
      }
      // console.log('add');
      this.records.push({
        group_alias: 'country_data',
        type: 'text',
        alias: 'title',
        int_value: 0,
        text_value: '',
        to_delete: false
      });
    },
    async getSuppliers() {
      this.loading = true;
      let {data} = await api.index('/new/suppliers?noPages=1');
      if (data.success) {
        this.suppliers = _.orderBy(data.records, 'title');
      }
      this.loading = false;
    }
  }
}

</script>

<style scoped>
.w-35 {
  width: 35%;
}
</style>
